// src/components/TopHeader.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUserCircle } from '@fortawesome/free-solid-svg-icons'; // Import user icon
import Banner from './Banner';
import { useAuth } from '../context/AuthContext';

const TopHeader: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();

  return (
    <div>
      <header className="flex items-center justify-between bg-gray-900 p-3 shadow-md">
        {/* Left: Home Icon */}
        <div className="flex items-center">
          <Link to="/" className="text-white text-xl font-semibold flex items-center">
            <FontAwesomeIcon icon={faHome} className="mr-2" />
            <span>Home</span>
          </Link>
        </div>

        {/* Center: Banner */}
        <div className="flex-grow text-center">
          <Banner />
        </div>

        {/* Right: User Info or Login Button */}
        <div className="flex items-center mr-3">
          {isAuthenticated ? (
            <div className="flex items-center space-x-3">
              {user?.profileImage ? (
                <img
                  src={user.profileImage}
                  alt="User"
                  className="w-10 h-10 rounded-full border-2 border-white"
                  title={user?.email || user?.username || 'User'}
                />
              ) : (
                <FontAwesomeIcon
                  icon={faUserCircle}
                  className="text-white text-3xl rounded-full border-2 border-white"
                  title={user?.email || user?.username || 'User'}
                />
              )}
              <button
                onClick={logout}
                className="text-sm bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition"
              >
                Logout
              </button>
            </div>
          ) : (
            <Link
              to="/login"
              className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 transition"
            >
              Login
            </Link>
          )}
        </div>
      </header>
    </div>
  );
};

export default TopHeader;